import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { v4 } from 'uuid';

import ResearchService from '@service/industry-research';

const moReport = observable({
  reportList: <any[]>[],
  allReportList: <any[]>[],
});

const initIndustryReport = action(async (res: any) => {
  // console.log('行业研报 初始化 init...');
  const newArr: any[] = cloneDeep(res) || [];
  const arr: any[] = cloneDeep(newArr.slice(0, 3));

  arr.map(item => {
    item.uuid = v4();
    item.active = false;
  });
  newArr.map(item => {
    item.uuid = v4();
    item.active = false;
  });
  runInAction(() => {
    moReport.reportList = arr;
    moReport.allReportList = newArr;
  });
});

const hoverCard = action((uuid: string) => {
  const arr = cloneDeep(moReport.allReportList);

  arr.map((item: any) => { if (item.uuid === uuid) item.active = true; });

  moReport.allReportList = arr;
});

const leaveCard = action((uuid: string) => {
  const arr = cloneDeep(moReport.allReportList);

  arr.map((item: any) => { if (item.uuid === uuid) item.active = false; });

  moReport.allReportList = arr;
});

// 点击更多
const onMore = action(() => {
  window.location.href = '/home/institute?part=1';
});

export default moReport;
export {
  initIndustryReport, hoverCard, leaveCard, onMore,
};
